<style lang="stylus">
    .FloatMenu-container
        position absolute
        left 50%
        top 50%
        transform translate(-50%, -50%)
        width 25px
        height 25px
        z-index 1
        user-select none
        .context-menu
            position absolute
            background #fff
            border .5px solid #ddd
            min-width 80px
            text-align center
            padding 3px
            z-index 2
            cursor pointer
        .context-menu:hover
            background: #eee;
        .folder-menu-box
            position fixed
            font-size: 12px;
            border-radius: 6px;
            box-shadow: 0 1px 6px rgba(0,0,0,.2);
            z-index: 99;
            background: #fff;
            padding 6px 0
            &.onlyOne
                >div:not(.delete)
                    cursor not-allowed
                    opacity 0.4
                    filter grayscale(1)
            .folder-menu-item
                height: 14px;
                line-height: 14px;
                font-size: 13px;
                position: relative;
                padding: 8px 20px;
                cursor: pointer;
                user-select: none;
                box-sizing: content-box;
                display flex
                align-items center
                white-space nowrap
                &:not(.ban):hover
                    background: #f5f7f6;
                img
                    margin: 0 12px;
            .folder-menu-item.ban
                cursor not-allowed
                color #a0a0a0
        .FloatMenu-onebtn
            position relative
            width 25px
            height 25px
            cursor pointer
            &:hover
                background-color $main-hovercolor
            .item-icon
                position absolute
                left 0
                right 0
                top 0
                bottom 0
                margin auto
                width 18px
                height 18px
        .FloatMenu-btn
            position relative
            width 25px
            height 25px
            border-radius 50%
            border 1px solid $box-bordercolor
            background-color var(--bg-color-tertiary)
            z-index 2
            cursor pointer
            .item-icon
                position absolute
                left 0
                right 0
                top 0
                bottom 0
                margin auto
                width 19px
                height 19px
                color var(--svg-color-float-menu-icon)
        .FloatMenu-contentMask
            position absolute
            left 12px
            top 0
            height 25px
            border 1px solid $box-bordercolor
            border-top-right-radius 3px
            border-bottom-right-radius 3px
            border-left unset
            background-color var(--bg-color-tertiary)
            z-index 1
            overflow hidden
            .FloatMenu-content
                height 23px
                display flex
                justify-content flex-start
                vertical-align middle
                .FloatMenu-contentBtn
                    position relative
                    width 35px
                    cursor pointer
                    &:not(:first-child)
                        border-left 1px solid $box-bordercolor
                    &:hover
                        background-color $main-hovercolor
                    .item-icon
                        position absolute
                        left 0
                        right 0
                        top 0
                        bottom 0
                        margin auto
                        width 18px
                        height 18px
                        color var(--svg-color-float-menu-icon)
        .FloatMenu-contentList
            position absolute
            top 25px
            padding 6px 0
            background-color var(--bg-color-tertiary)
            border-radius 3px
            box-shadow $box-shadow
            list-style none
            li
                padding 5px 0px 5px 0px
                cursor pointer
                &:hover
                    background-color $main-hovercolor
                div
                    position relative
                    width 100%
                    height 18px
                .hylink-list
                    display flex
                    align-items center
                    padding 0 6px
                    min-width 98px
                    height 22px
                    p
                        padding 0
                img,.item-icon
                    width 20px
                    height 20px
                    margin-right 4px
                .item-icon
                    fill var(--svg-color-float-menu-icon)
                p
                    vertical-align middle
                    padding 0px 20px 0px 20px
                    // padding-right 15px
                    white-space nowrap
                .checked::before
                    line-height 0
                    content url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' %3E%3Cpath stroke='%23424242' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round' d='M4 8l2.5 2.5L12 5'/%3E%3C/svg%3E")
                    position absolute
                    display block
                    left 0
                    top 2px
                    width 16px
                    height 16px
            .rightClick
                background-color $main-hovercolor
        .FloatMenu-expandNote
            position absolute
            top 25px
            display inline-block
            max-width 400px
            padding 10px
            border-radius 3px
            border 1px solid #ffdcbf
            background-color var(--bg-color-float-menu-expand-note)
            max-height 300px
            overflow auto
            .note-function
                position absolute
                right 10px
                top 0
                display flex
                align-items center
                background var(--bg-color-float-menu-expand-note)
            .expandNote-nail
                margin-right 8px
                width 16px
                height 16px
                cursor pointer
                display inline-block
                img
                    width 100%
                    height 100%
                    object-fit contain
                &:hover
                    background-color $main-hovercolor
            .expandNote-delete
                width 16px
                height 16px
                cursor pointer
                display flex
                align-items center
                justify-content center
                .item-icon
                    width 12px
                    height 12px
                    fill #f5bb42
                    stroke #f5bb42
                &:hover
                    background-color $main-hovercolor
            .expandNote-text
                margin-top 5px
                width 100%
                word-break break-word
                img
                    max-width 100%
        .FloatMenu-expandComment
            position absolute
            top 25px
            display inline-block
            max-width 500px
            padding 10px
            border-radius 3px
            border 1px solid var(--border-color-float-expand-comment)
            background-color var(--bg-color-tertiary)
            max-height 300px
            overflow auto
            .expandComment-box
                position relative
                min-width 200px
                margin-bottom 5px
                display flex
                justify-content space-around
                flex-wrap wrap
                .expandComment-user
                    width calc(100% - 115px)
                    overflow hidden
                    text-overflow ellipsis
                    white-space nowrap
                    color #66ccff
                .expandComment-time
                    width 115px
                    text-align right
                    color #c1c1c1
                .expandComment-content
                    width 100%
                    text-indent 10px
                    word-break break-word
        .FloatMenu-expandAttach
            position absolute
            top 25px
            display inline-block
            max-width 120px
            border-radius 3px
            border 1px solid var(--border-color-float-expand-comment)
            background-color var(--bg-color-tertiary)
            .expandAttach-box
                position relative
                min-width 100px
                .expandAttach-name
                    width 100%
                    text-indent 10px
                    height 22px
                    line-height 22px
                    white-space nowrap
                    text-overflow ellipsis
                    overflow hidden
                    word-break break-all
                    &:hover
                        background-color $main-hovercolor
            .rightClick
                background-color $main-hovercolor
        &.FloatMenu-ignore
            display none
</style>

<template>
    <div
        class="FloatMenu-container"
        :style="{ left: `${left}px`, top: `${top}px` }"
        :class="{ 'FloatMenu-ignore': isToolOperating }"
        @mouseleave="mouseleaveOperation"
    >
        <div
            class="FloatMenu-onebtn"
            v-if="showFloatBtn && hasAction && (floatItem.show || shapeID == itemID) && actionsList.length > 0 && !isShareFile"
            :style="showList.length > 0 ? `position:absolute;top:-${actionTopOffset}px` : ''"
            @click="showBox(actionBtn.name, actionBtn.id, 0)"
            @mouseenter="
                toggleMenu(false);
                showExpandbox(actionBtn.id, 0);
            "
        >
            <iconSymbol class="item-icon" :name="actionBtn.svgName" />
        </div>
        <!-- 一个icon -->
        <div
            class="FloatMenu-onebtn"
            v-if="showList.length == 1"
            @click="showBox(showList[0].name, showList[0].id, 0)"
            @mouseenter="showExpandbox(showList[0].id, 0)"
            @mousedown.stop=""
            @mouseup.stop="showContextmenu($event, 0, 'all')"
        >
            <iconSymbol class="item-icon" :name="showList[0].svgName" />
        </div>
        <!-- <div class="context-menu" :style="'top:15px;left:20px;'" @click="delToggleMenu(showList[0])" v-show=" contextMenuFlag === 'all' && contextMenuNum === 0 " v-text="$t('floatMenuDelete')"></div> -->
        <!-- 多个icon -->
        <div class="FloatMenu-btn" v-if="showList.length > 1" @mouseenter="toggleMenu(true)">
            <iconSymbol class="item-icon" name="floatMenu-more" />
        </div>
        <div class="FloatMenu-contentMask" v-if="showList.length > 1" :style="{ width: `${showWidth}px`, paddingLeft: showWidth > 0 ? '15px' : 0 }">
            <div class="FloatMenu-content">
                <div
                    class="FloatMenu-contentBtn"
                    v-for="(item, index) in showList"
                    :key="item.id"
                    @click="showBox(item.name, item.id, index)"
                    @mouseenter="showExpandbox(item.id, index)"
                    @mousedown.stop=""
                    @mouseup.stop="showContextmenu($event, index, 'all')"
                >
                    <iconSymbol class="item-icon" :name="item.svgName" />
                </div>
            </div>
        </div>
        <div
            class="context-menu"
            :style="showList.length == 1 ? 'top:15px;left:15px;' : 'top:20px;left:' + (50 + contextMenuNum * 30) + 'px;'"
            @click="delToggleMenu(showList[contextMenuNum])"
            v-show="contextMenuFlag === 'all' && contextMenuNum > -1 && !isShareFile"
            v-text="$t('floatMenuDelete')"
        ></div>
        <ul
            v-show="showAction"
            ref="actionList"
            :style="{ left: `${ExpandLeft}px`, top: `${ExpandTop - actionTopOffset}px` }"
            class="FloatMenu-contentList"
            @mouseleave="closeExpandbox()"
        >
            <li v-for="item in actionsList" :key="item.id" @click="clickActionList(item.id)">
                <div :class="{ checked: item.isCheck, 'ft-has-checked-list-item': item.isCheck }">
                    <p :title="item.name">{{ item.name.length > 10 ? item.name.slice(0, 10) + "..." : item.name }}</p>
                </div>
            </li>
        </ul>
        <!-- 超链接 -->
        <ul
            v-show="showHylink"
            ref="hylinkList"
            :style="{ left: `${ExpandLeft}px`, top: `${ExpandTop}px` }"
            class="FloatMenu-contentList"
            @mouseleave="closeExpandbox()"
            @mouseenter="mouseenterOperation"
        >
            <li
                v-for="(item, index) in hyperlinkList"
                :key="item.id"
                @click="clickHylinkList(item.id)"
                @mousedown.stop=""
                @mouseup.stop="showContextmenu($event, index, 'hylink')"
                :class="index === contextMenuNum && contextMenuFlag === 'hylink' ? 'rightClick' : ''"
            >
                <div class="hylink-list" :class="{ checked: item.isCheck, 'ft-has-checked-list-item': item.isCheck }">
                    <!-- 当前页 -->
                    <iconSymbol v-if="item.type == 1" class="item-icon" name="hylink-menu1" />
                    <!-- 网络地址 -->
                    <iconSymbol v-if="item.type == 3" class="item-icon" name="hylink-menu2" />
                    <!-- 云文档 -->
                    <img v-if="item.type == 5" src="@/app/assets/img/dialog/hyperlink/cloudFile/file.svg" alt="" />
                    <!-- 最多10字 -->
                    <p :title="item.type == 5 && item.linkName ? item.linkName : item.name">
                        {{
                            item.type == 5 && item.linkName
                                ? item.linkName.length > 10
                                    ? item.linkName.slice(0, 10) + "..."
                                    : item.linkName
                                : item.name.length > 10
                                  ? item.name.slice(0, 10) + "..."
                                  : item.name
                        }}
                    </p>
                </div>
            </li>
            <div
                class="folder-menu-box"
                :class="{ onlyOne: hyperlinkList.length === 1 }"
                :style="{ left: `${ExpandLeft + floatMenuListWidth}px`, top: `${ExpandTop}px` }"
                v-if="contextMenuFlag === 'hylink' && !isShareFile"
            >
                <div class="folder-menu-item" @click="moveTo('top')">
                    <span>{{ $t("moveTop") }}</span>
                </div>
                <div class="folder-menu-item" @click="moveTo('bottom')">
                    <span>{{ $t("moveBottom") }}</span>
                </div>
                <div class="folder-menu-item" @click="moveTo('up')">
                    <span>{{ $t("moveUp") }}</span>
                </div>
                <div class="folder-menu-item" @click="moveTo('down')">
                    <span>{{ $t("moveDown") }}</span>
                </div>
                <div class="folder-menu-item delete" @click="delToggleList()">
                    <span>{{ $t("floatMenuDelete") }}</span>
                </div>
            </div>
        </ul>
        <!-- 注释 -->
        <div
            @scroll="noteScroll"
            v-show="showNoteExpand"
            ref="noteList"
            :style="{ left: `${ExpandLeft}px`, top: `${ExpandTop}px`, width: `${noteWidth}px` }"
            class="FloatMenu-expandNote"
        >
            <div class="note-function" ref="noteFunction">
                <div class="expandNote-nail" :title="$t('lockNoteTips')" @click="lockNote()" v-if="!isShareFile">
                    <img src="@/app/assets/img/note/pinned.png" alt="" />
                </div>
                <div class="expandNote-delete" :title="$t('deleteNoteTips')" @click="cleanNote()" v-if="!isShareFile">
                    <iconSymbol class="item-icon" name="DelTrash" />
                </div>
            </div>

            <p class="expandNote-text" v-html="noteText"></p>
        </div>
        <!-- 评论 -->
        <div v-show="showCommentExpand" ref="commentList" :style="{ left: `${ExpandLeft}px`, top: `${ExpandTop}px` }" class="FloatMenu-expandComment">
            <div class="expandComment-box" v-for="item in commentList">
                <p class="expandComment-user">{{ item.name + ":" }}</p>
                <p class="expandComment-time">{{ getDate(item.date) }}</p>
                <p class="expandComment-content">{{ item.msg }}</p>
            </div>
        </div>
        <!-- 附件 -->
        <div v-show="showAttachExpand" ref="attachList" :style="{ left: `${ExpandLeft}px`, top: `${ExpandTop}px` }" class="FloatMenu-expandAttach">
            <div
                class="expandAttach-box"
                v-for="(item, index) in attachList"
                @mousedown.stop=""
                @mouseup.stop="showContextmenu($event, index, 'attach')"
                :class="index === contextMenuNum && contextMenuFlag === 'attach' ? 'rightClick' : ''"
            >
                <div @click="downAttach(index)" :title="item._name" class="expandAttach-name">{{ item._name }}</div>
            </div>
            <div
                class="folder-menu-box"
                :style="{ left: `${ExpandLeft + floatMenuListWidth}px`, top: `${ExpandTop}px` }"
                v-if="contextMenuFlag === 'attach' && !isShareFile"
            >
                <div class="folder-menu-item" @click="moveTo('top')">
                    <span>{{ $t("moveTop") }}</span>
                </div>
                <div class="folder-menu-item" @click="moveTo('bottom')">
                    <span>{{ $t("moveBottom") }}</span>
                </div>
                <div class="folder-menu-item" @click="moveTo('up')">
                    <span>{{ $t("moveUp") }}</span>
                </div>
                <div class="folder-menu-item" @click="moveTo('down')">
                    <span>{{ $t("moveDown") }}</span>
                </div>
                <div class="folder-menu-item" @click="delToggleList()">
                    <span>{{ $t("floatMenuDelete") }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    declare var egPoint: any;
    @Component({
        components: {},
    })
    export default class FloatMenu extends Vue {
        @Prop()
        itemID: number;
        @Prop()
        item: any;
        floatItemIndex: number = -1;
        dataIndex: number = 0;
        baseWidth: number = 0;
        showWidth: number = 0;
        showAction: boolean = false;
        showHylink: boolean = false;
        showNoteExpand: boolean = false;
        showCommentExpand: boolean = false;
        showAttachExpand: boolean = false;
        noteWidth: number = 0;
        ExpandLeft: number = 0;
        floatMenuListWidth: number = 0;
        ExpandTop: number = 25;
        actionBtn: object = {
            id: 0,
            name: "action",
            svgName: "floatMenu-action",
        };
        hasAction: boolean = false; // 判断形状是否有action按钮
        menuBtn: object = {
            // 'action': {
            //     id: 0,
            //     name: 'action',
            //     svgName: 'floatMenu-action',
            // },
            hylink: {
                id: 1,
                name: "hylink",
                svgName: "floatMenu-hylink",
            },
            note: {
                id: 2,
                name: "note",
                svgName: "floatMenu-note",
            },
            comment: {
                id: 3,
                name: "comment",
                svgName: "floatMenu-conmment",
            },
            attach: {
                id: 4,
                name: "attach",
                svgName: "floatMenu-attachment",
            },
        };
        showList: Array<object> = []; // 浮动按钮列表
        expandDataList: Array<object> = []; // 拓展窗口列表
        contextMenuNum: Number = -1;
        contextMenuFlag: String = "all";
        closeTimer: number | null = null;

        mouseleaveOperation() {
            clearTimeout(this.closeTimer);
            this.closeTimer = setTimeout(() => {
                this.toggleMenu(false);
                this.closeExpandbox();
            }, 150);
        }

        mouseenterOperation() {
            clearTimeout(this.closeTimer);
        }
        downAttach(index) {
            let id = this.itemID;
            console.log(id);
            window["_view"].downAttachment(id, index);
        }

        // tool
        getDate(timestamp) {
            return new Date(timestamp * 1000).toLocaleString();
        }
        getFloatItemIndex() {
            let index = -1;
            for (let i = 0; i < this.floatMenuList.length; i++) {
                if (this.itemID == this.floatMenuList[i].id) {
                    index = i;
                    break;
                }
            }
            return index;
        }
        // 其他弹窗
        openDialog(type) {
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: type,
            });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
        }
        showBox(name, id, index) {
            // 打开相应弹窗
            if (this.isPreviewView || this.isShareFile) {
                // 群组视图屏蔽事件
                return;
            }
            this.activeFloatItem = this.floatItemIndex;
            let flag = 0;
            switch (name) {
                case "hylink":
                    this.openDialog("hyperlink");
                    break;
                case "comment":
                    this.openDialog("comment");
                    break;
                case "note":
                    this.openDialog("note");
                    break;
                case "attach":
                    this.openDialog("attach");
                    break;
                case "action":
                    if (!this.showAction) {
                        flag = 1;
                        this.showExpandbox(id, index);
                    }
                    break;
            }
            !flag && this.closeExpandbox();
            // 有菜单icon，说明已经选中了
            // this.selectItem();
        }
        selectItem() {
            // 选中点击的shape
            let view = window["_view"];
            let item = view._activePage.getItemByID(this.itemID);
            if (item) {
                view.selectObject(item);
                view.invalidate();
            }
        }

        // 拓展菜单相关
        adjustExpandBox() {
            // 调整弹窗位置
            let dom,
                rightMenu = this.$store.state.ui.showRightPanel ? 320 : 40,
                menuWidth = 0;
            if (this.showAction) {
                dom = this.$refs.actionList as HTMLElement;
            } else if (this.showHylink) {
                dom = this.$refs.hylinkList as HTMLElement;
            } else if (this.showNoteExpand) {
                dom = this.$refs.noteList as HTMLElement;
            } else if (this.showCommentExpand) {
                dom = this.$refs.commentList as HTMLElement;
            } else if (this.showAttachExpand) {
                dom = this.$refs.attachList as HTMLElement;
            }
            // if(this.actionsList.length > 0){
            //     menuWidth += 35
            // }
            if (this.noteText != "") {
                menuWidth += 35;
            }
            if (this.commentList.length > 0) {
                menuWidth += 35;
            }
            if (this.hyperlinkList.length > 0) {
                menuWidth += 35;
            }
            if (this.attachList.length > 0) {
                menuWidth += 35;
            }
            let itemW = dom.offsetWidth,
                itemH = dom.offsetHeight,
                winW = window.innerWidth,
                winH = window.innerHeight,
                parentL = dom.parentNode.getBoundingClientRect()["x"],
                parentT = dom.parentNode.getBoundingClientRect()["y"];

            if (this.showList.length > 1) {
                if (itemH + parentT + 25 > winH) {
                    if (this.showAction) this.ExpandTop = -itemH + 25;
                    else this.ExpandTop = -itemH;
                } else {
                    if (this.showAction) this.ExpandTop = 0;
                    else this.ExpandTop = 25;
                }
                if (itemW + parentL + rightMenu + menuWidth > winW) {
                    if (this.showAction) this.ExpandLeft -= itemW + 25;
                    else this.ExpandLeft -= itemW - 35;
                }
            } else {
                if (itemH + parentT > winH) {
                    this.ExpandTop = -itemH + 25;
                } else {
                    this.ExpandTop = 15;
                }
                if (itemW + parentL + rightMenu + menuWidth + 25 > winW) {
                    this.ExpandLeft -= itemW;
                } else {
                    this.ExpandLeft = 25;
                }
            }
        }
        showExpandbox(id, index) {
            // 显示拓展菜单
            if (this.isPreviewView) {
                // 群组视图屏蔽事件
                return;
            }
            this.activeHoverFloatID = this.itemID;
            this.closeExpandbox();
            let offset = this.showList.length > 1 ? 25 : 0; // 是否有偏移
            this.ExpandLeft = index * 35 + offset;

            if (id == 0) {
                this.showAction = true;
            } else if (id == 1) {
                this.showHylink = true;
            } else if (id == 2) {
                // note
                let note = window["_view"]._activePage.getItemByID(this.itemID).getNote();
                if (note._locked) return;
                this.noteWidth = note._width + 24;
                this.showNoteExpand = true;
            } else if (id == 3) {
                // comment
                this.showCommentExpand = true;
            } else if (id == 4) {
                this.showAttachExpand = true;
            }
            this.$nextTick(() => {
                this.adjustExpandBox();
            });
        }
        closeExpandbox() {
            // 关闭拓展菜单
            this.showAction = false;
            this.showHylink = false;
            this.showNoteExpand = false;
            this.showCommentExpand = false;
            this.showAttachExpand = false;
        }
        lockNote() {
            this.showNoteExpand = false;
            // let temp = JSON.parse(JSON.stringify(this.floatItem))
            // for(let i = 0; i < temp.menuList.length; ++i){
            //     if(temp.menuList[i] == 'note'){
            //         temp.menuList.splice(i, 1)
            //         break
            //     }
            // }
            // this.$store.commit('updateFloatMenuList', temp)

            let view = window["_view"];
            let item = view._activePage.getItemByID(this.itemID);
            item.getNote()._locked = !item.getNote()._locked;
            if (item.getNote()._locked) {
                let pt = new egPoint(item.width - item.localPin().x, -item.localPin().y);
                item.getNote()._pos = pt;
                item.getNote().drawNote(item);
            }
        }
        // 右键显示删除浮动的菜单
        showContextmenu(event, index, name) {
            console.log(event.target.clientWidth);
            if (event.button == 2) {
                this.floatMenuListWidth = event.target.clientWidth;
                this.contextMenuFlag = name;
                this.contextMenuNum = index;
                // debugger;
            }
            event.stopPropagation();
            event.preventDefault();
        }
        // 点击删除浮动菜单
        delToggleMenu(item) {
            this.activeFloatItem = this.floatItemIndex;
            let name = item.name;
            // let flag = 0;
            let view = window["_view"];
            let id = this.itemID;
            let len: number;
            switch (name) {
                case "hylink":
                    len = this.item.hyperlinkList._hyperlinks.length;
                    view.deleteHyperlink(len - 1, id, "clean");
                    this.showHylink = false;
                    break;
                case "comment":
                    len = this.item.commentList._comments.length;
                    view.removeComment(len - 1, id, "clean");
                    this.showCommentExpand = false;
                    break;
                case "note":
                    this.cleanNote(); // 移除注释
                    this.showNoteExpand = false;
                    break;
                case "attach":
                    len = this.item.attachList._attachs.length;
                    view.deleteAttach(len - 1, id, "clean");
                    this.showAttachExpand = false;
                    break;
                // case 'action':
                //     if(!this.showAction){
                //         flag = 1;
                //     }
                //     break
            }
            this.contextMenuNum = -1;
            this.contextMenuFlag = "all";
            event.stopPropagation();
        }
        delToggleList() {
            this.activeFloatItem = this.floatItemIndex;
            let id = this.itemID;
            switch (this.contextMenuFlag) {
                case "hylink":
                    window["_view"].deleteHyperlink(this.contextMenuNum, id);
                    this.showHylink = false;
                    break;
                case "attach":
                    window["_view"].deleteAttach(this.contextMenuNum, id);
                    this.showAttachExpand = false;
                    break;
            }
            this.contextMenuNum = -1;
            this.contextMenuFlag = "all";
        }
        moveTo(operate) {
            // 打开相应弹窗
            this.activeFloatItem = this.floatItemIndex;
            let id = this.itemID;
            let len: number = 0;
            enum moveTypeIndex {
                up = 0,
                down = 1,
                top = 2,
                bottom = 3,
            }
            switch (this.contextMenuFlag) {
                case "hylink":
                    len = this.item.hyperlinkList._hyperlinks.length;
                    window["_view"].moveHyperlink(this.contextMenuNum, moveTypeIndex[operate], id);
                    break;
                case "attach":
                    len = this.item.attachList._attachs.length;
                    window["_view"].moveAttach(this.contextMenuNum, moveTypeIndex[operate], id);
                    break;
            }
            let moveType = {
                up: <number>this.contextMenuNum - 1,
                down: <number>this.contextMenuNum + 1,
                top: 0,
                bottom: len - 1,
            };
            if ((this.contextMenuNum == 0 && moveType[operate] <= 0) || (this.contextMenuNum == len - 1 && moveType[operate] >= len - 1)) {
                console.error("index error. check index");
            } else {
                this.contextMenuNum = moveType[operate];
            }
            event.stopPropagation();
            event.preventDefault();
        }
        cleanNote() {
            this.showNoteExpand = false;
            let view = window["_view"];
            view.editNote("", this.itemID);
        }
        clickActionList(id) {
            let view = window["_view"];
            let item = view._activePage.getItemByID(this.itemID);
            this.activeFloatItem = this.floatItemIndex;
            view.fmlDoShapeAction(item, id, 0);
            this.closeExpandbox();
        }
        clickHylinkList(id) {
            let view = window["_view"];
            let item = view._activePage.getItemByID(this.itemID);
            this.activeFloatItem = this.floatItemIndex;
            view.doHyperlink(item, id, -1, -1);
            this.closeExpandbox();
        }
        toggleMenu(flag) {
            // 显隐浮动菜单
            if (this.isPreviewView) {
                // 群组视图屏蔽事件
                return;
            }
            if (!flag) {
                this.showWidth = 0;
                this.contextMenuNum = -1;
                this.contextMenuFlag = "all";
                this.closeExpandbox();
            } else {
                this.showWidth = this.baseWidth + 15;
            }
        }

        // 数据初始化
        initData() {
            // 初始化按钮个数，按钮总宽度
            this.floatItemIndex = this.getFloatItemIndex();
            this.showList = [];
            this.baseWidth = 0;

            let nameList = Object.keys(this.menuBtn);
            for (let name of nameList) {
                if (this.menuList.includes(name) && name != "action") {
                    this.showList.splice(this.showList.length, 0, this.menuBtn[name]);
                    this.baseWidth += 35;
                }
            }
            // if(this.menuList.includes('action')){
            //     this.hasAction = true;
            // }
        }

        get isToolOperating() {
            return this.$store.state.shape.isToolOperating;
        }
        get floatMenuList() {
            return this.$store.state.dialog.floatMenuList;
        }
        get left() {
            return this.item.position ? this.item.position[0] : 0;
        }
        get top() {
            return this.item.position ? this.item.position[1] : 0;
        }
        get actionTopOffset() {
            if (this.showList.length > 0) return 25;
            else return 0;
        }
        get actionsList() {
            let actions = this.item.actionsList._actions;
            if (actions.length != 0) {
                let arr = actions.map((v: any, k) => {
                    return {
                        name: v._menuDisp || v._menu._string,
                        id: v._id,
                        isVisible: !v._invisible._bool,
                        isAble: !v._disable._bool,
                        isCheck: v._check._bool,
                    };
                });
                return arr.filter((v: any, k) => {
                    return v.isVisible && v.isAble;
                });
            } else {
                return [];
            }
        }
        get hyperlinkList() {
            let hylink = this.item.hyperlinkList._hyperlinks;
            if (hylink.length != 0) {
                return hylink.map((v: any, k) => {
                    let obj = {
                        id: v._id,
                        name: v._description,
                        address: v._subAddress,
                        type: v._type,
                        linkName: v._linkName,
                    };
                    return obj;
                });
            } else {
                return [];
            }
        }
        get commentList() {
            let data;
            if (!this.item.commentList) {
                data = [];
            } else {
                data = this.item.commentList._comments.map((v: any, k) => {
                    let obj = {
                        date: v._date,
                        email: v._email,
                        msg: v._msg,
                        name: v._name,
                    };
                    return obj;
                });
            }
            return data;
        }
        get attachList() {
            return this.item.attachList._attachs;
        }
        get noteText() {
            return this.item.noteText;
        }
        get menuList() {
            return this.item.menuList || [];
        }
        get activeFloatItem() {
            return this.$store.state.dialog.activeFloatItem;
        }
        set activeFloatItem(v) {
            this.$store.commit("setDialogState", {
                type: "activeFloatItem",
                data: v,
            });
        }
        get floatItem() {
            return this.item;
        }
        get activeHoverFloatID() {
            return this.$store.state.dialog.activeHoverFloatID;
        }
        set activeHoverFloatID(v) {
            this.$store.commit("setDialogState", {
                type: "activeHoverFloatID",
                data: v,
            });
        }
        get showFloatBtn() {
            //显示action菜单
            return this.$store.state.page.showFloatBtn;
        }
        get shapeID() {
            return this.$store.state.shape.id;
        }
        get isGroupView() {
            return this.$store.state.ui.isGroupView;
        }
        get isPreviewView() {
            return this.$store.state.ui.isPreviewView;
        }
        get isShareFile() {
            return this.$store.state.ui.isShareFile;
        }
        // @Watch('menuList')
        // watchMenuList(){
        //     this.initData()
        //     if(this.showWidth != 0){
        //         this.showWidth = this.baseWidth + 15;
        //     }
        // }
        @Watch("item.menuList")
        watchItemChange(nv, ov) {
            if (nv.toString() != ov.toString()) {
                console.log("watch item change");
                this.initData();
            }
        }
        mounted() {
            this.initData();
        }
        scrollDoing = false;
        noteScroll(e) {
            if (this.scrollDoing) return;
            window.requestAnimationFrame(() => {
                const el = this.$refs.noteFunction as HTMLDivElement;
                el.style.top = e.target.scrollTop + "px";
                el.style.willChange = "top";
                this.scrollDoing = false;
            });
        }
        created() {
            let ts: any = this;
            ts.$bus.$on("expandFloatMenu", (data) => {
                if (data.id != this.itemID) return;
                if (!data.data) {
                    this.showWidth = 0;
                    this.closeExpandbox();
                } else {
                    this.showWidth = this.baseWidth + 15;
                }
            });
        }
        beforeDestroy() {
            // 移除相关事件
            let ts: any = this;
            ts.$bus.$off("expandFloatMenu");
        }
    }
</script>
<i18n>
{
  "zh": {
    "deleteNoteTips": "删除注释",
    "lockNoteTips": "固定注释",
    "floatMenuDelete": "删除",
    "moveTop": "移至最前",
    "moveBottom": "移至最后",
    "moveUp": "上移",
    "moveDown": "下移"
  },
  "en": {
    "deleteNoteTips": "Delete Note",
    "lockNoteTips": "Lock Note",
    "floatMenuDelete": "Delete",
    "moveTop": "Move to the front",
    "moveBottom": "Move to the end",
    "moveUp": "Move up",
    "moveDown": "Move down"
  },
  "jp": {
    "deleteNoteTips": "注釈を削除",
    "lockNoteTips": "注釈のピン留め",
    "floatMenuDelete": "削除する",
    "moveTop": "前に移動",
    "moveBottom": "最後に移動",
    "moveUp": "上に移動",
    "moveDown": "下に移動"
  },
  "fr": {
    "deleteNoteTips": "Supprimer le Commentaire",
    "lockNoteTips": "Fixes Remarques ",
    "floatMenuDelete": "supprimer",
    "moveTop": "Déplacer vers l'avant",
    "moveBottom": "Aller à la fin",
    "moveUp": "Déplacer vers le haut",
    "moveDown": "Descendre"
  },
  "de": {
    "deleteNoteTips": "Notiz löschen",
    "lockNoteTips": "Notiz sperren",
    "floatMenuDelete": "löschen",
    "moveTop": "Bewegen Sie sich nach vorne",
    "moveBottom": "Gehe zum Ende",
    "moveUp": "Bewegen Sie sich nach oben",
    "moveDown": "Sich abwärts bewegen"
  },
  "es": {
    "deleteNoteTips": "Borrar Nota",
    "lockNoteTips": "Bloquear Nota",
    "floatMenuDelete": "Eliminar",
    "moveTop": "Mover al frente",
    "moveBottom": "Muévete hasta el final",
    "moveUp": "Ascender",
    "moveDown": "Mover hacia abajo"
  },
  "pt": {
    "deleteNoteTips": "Eliminar Nota",
    "lockNoteTips": "Bloquear Nota",
    "floatMenuDelete": "excluir",
    "moveTop": "Vá para a frente",
    "moveBottom": "Vá para o fim",
    "moveUp": "Subir",
    "moveDown": "Mova para baixo"
  },
  "it": {
    "deleteNoteTips": "Elimina Nota",
    "lockNoteTips": "Blocca Nota",
    "floatMenuDelete": "Elimina",
    "moveTop": "Spostati in primo piano",
    "moveBottom": "Vai alla fine",
    "moveUp": "Andare avanti",
    "moveDown": "Abbassati"
  },
  "tw": {
    "deleteNoteTips": "刪除注釋",
    "lockNoteTips": "固定注釋",
    "floatMenuDelete": "刪除",
    "moveTop": "移至最前",
    "moveBottom": "移至最後",
    "moveUp": "上移",
    "moveDown": "下移"
  },
  "kr": {
    "deleteNoteTips": "주석 삭제",
    "lockNoteTips": "주석 잠금",
    "floatMenuDelete": "삭제",
    "moveTop": "앞으로 이동",
    "moveBottom": "맨 끝으로 이동",
    "moveUp": "위로 이동",
    "moveDown": "아래로 이동"
  }
}
</i18n>
